(function () {
  const DURATION_MS = {
    every_2_hrs: 2 * 60 * 60 * 1000,
    every_6_hrs: 6 * 60 * 60 * 1000,
    every_12_hrs: 12 * 60 * 60 * 1000,
    every_24_hrs: 24 * 60 * 60 * 1000,
    every_week: 7 * 24 * 60 * 60 * 1000,
    every_month: 30 * 24 * 60 * 60 * 1000,
  };

  function readTarget(key) {
    try {
      return parseInt(localStorage.getItem(key), 10);
    } catch (e) {
      return NaN;
    }
  }

  function writeTarget(key, value) {
    try {
      localStorage.setItem(key, String(value));
    } catch (e) {
      /* localStorage blocked — non-fatal, countdown just won't persist */
    }
  }

  function clearTarget(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      /* noop */
    }
  }

  function getTargetTime(el) {
    if (el.dataset.mode === 'fixed_date') {
      const raw = (el.dataset.fixedTime || '').trim();
      if (!raw) return null;
      const t = Date.parse(raw);
      return isNaN(t) ? null : t;
    }

    const duration = el.dataset.duration;
    const span = DURATION_MS[duration] || DURATION_MS.every_24_hrs;
    const key = 'ihPromoCountdown:' + duration;

    let target = readTarget(key);
    if (!target || target < Date.now()) {
      target = Date.now() + span;
      writeTarget(key, target);
    }
    return target;
  }

  function format(ms) {
    if (ms < 0) ms = 0;
    const pad = (n) => String(n).padStart(2, '0');
    return {
      d: pad(Math.floor(ms / 86400000)),
      h: pad(Math.floor((ms % 86400000) / 3600000)),
      m: pad(Math.floor((ms % 3600000) / 60000)),
      s: pad(Math.floor((ms % 60000) / 1000)),
    };
  }

  class IhPromoAlertCountdown extends HTMLElement {
    connectedCallback() {
      this.days = this.querySelector('[data-cd-days]');
      this.hours = this.querySelector('[data-cd-hours]');
      this.mins = this.querySelector('[data-cd-mins]');
      this.secs = this.querySelector('[data-cd-secs]');
      if (!this.days || !this.hours || !this.mins || !this.secs) return;

      this.target = getTargetTime(this);
      if (this.target === null) {
        this.setDigits('', '', '', '');
        return;
      }

      this.tick = this.tick.bind(this);
      this.tick();
      this.intervalId = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    setDigits(d, h, m, s) {
      this.days.textContent = d;
      this.hours.textContent = h;
      this.mins.textContent = m;
      this.secs.textContent = s;
    }

    tick() {
      const remaining = this.target - Date.now();
      const parts = format(remaining);
      this.setDigits(parts.d, parts.h, parts.m, parts.s);

      if (remaining <= 0) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;

        if (this.dataset.mode === 'evergreen') {
          clearTarget('ihPromoCountdown:' + this.dataset.duration);
          this.target = getTargetTime(this);
          if (this.target !== null) {
            this.intervalId = window.setInterval(this.tick, 1000);
          }
        }
      }
    }
  }

  if (!customElements.get('ih-promo-alert-countdown')) {
    customElements.define('ih-promo-alert-countdown', IhPromoAlertCountdown);
  }
})();
